<template>
  <div class="club-container">
    <div class="image-container">
      <node-element-local-tasks :itemid="club.id" :options="{ mode: 'view', ...(single ? {} : {destination: '/wineclubs'}) }" />
      <AImage
        v-if="club.image && club.image.filepath"
        :img="club.image"
        preset="wineclubteaser"
      />
      <div
        v-else
        class="image-placeholder"
      />
      <div class="title-container">
        <h1>{{ club.title }}</h1>
        <p v-html="club.abstract" />
      </div>
    </div>
    <div
      class="club-description"
      v-html="club.body"
    />
    <template v-if="club.customclub">
      <h2
        class="products-headline"
      >
        Available Products For This Custom Club
      </h2>
      <section class="products">
        <div class="products-container">
          <Product
            v-for="product in products"
            :key="product.id"
            :product="product"
            :custom-club="club.customclub"
          />
        </div>
      </section>
    </template>
    <h2 class="selections-headline">Selections For This Club</h2>
    <section class="selections">
      <div class="selections-container">
        <Selections
          v-for="(item, index) in club.selections"
          :key="item.id"
          :selection="item"
          :index="index + 1"
          :custom-club="club.customclub"
          :is-minified="isMinified"
        />
      </div>
    </section>
  </div>
</template>

<script>
import Selections from "./Selections";
import Product from "./Product";

export default {
  name: "club-container",
  components: {
    Selections,
    Product
  },
  props: {
    club: {
      type: Object,
      required: true
    },
    single: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    isMinified() {
      return true
    },
    products() {
      if (!this.club.customclub) {
        return []
      }
      return Object.values(this.$store.state.somnambulistui.products).filter(product => product.wine_club.includes(this.club.clubid))
    }
  }
};
</script>

<style scoped lang="scss">
.club-container {
  margin: 4em 0;
  .image-container {
    position: relative;
    background: var(--main-image-background-color);
    .image-placeholder {
      background-color: var(--main-image-background-color);
      padding-bottom: 56.25%;
    }
    .title-container {
      position: absolute;
      display: inline-block;
      background: var(--main-wine-club-list-hero-block-background-color);
      color: var(--main-wine-club-list-hero-block-text-color);
      top: 3em;
      left: -1em;
      padding: 1em 3em 1em 3em;
      width: 20em;
      z-index: 1;
      p {
        font-size: 1.2em;
      }
      &:after {
        content: "";
        width: 0;
        height: 0;
        border-left: 1em solid transparent;
        border-right: 0px solid transparent;
        border-top: 1em solid var(--main-badge-background-color);
        bottom: -1em;
        left: 0;
        position: absolute;
      }
    }
  }
  .club-description {
    font-size: 1.2em;
    padding: 1em 1em 2em 1em;
  }
  .selections-headline, .products-headline {
    text-align: center;
  }
  .selections {
    padding-top: 1em;
    h3 {
      border-bottom: 2px solid var(--main-border-color);
      margin: 0 1em;
      padding-bottom: 0.5em;
    }
    .selections-container {
      margin: 0 -1em;
      padding: 0 1em;
    }
  }
  .products {
    margin-bottom: 1em;
    .products-container {
      display: flex;
      justify-content: space-between;
      margin: 0;
      flex-wrap: wrap;
      .product {
        background: var(--main-card-background-color);
        color: var(--main-card-text-color);
        box-shadow: var(--main-card-drop-shadow);
        border-radius: var(--main-card-border-radius);
      }
    }
  }
  .cta-container {
    padding: 4em 0;
    text-align: center;
    .btn.btn-cta {
      font-size: 1.4em !important;
    }
  }
}
</style>
